const theme = {
  colors: {
    Fiord: "#404E67",
    darkBlue: "#233b67",
    grayscale_black: "#252733",
    white: "white",
    purpel: "#b36cdb",
    lightSkyBlue: " #f7f7ff",
    themedColor: "#6789C5",
    pink: "#FF5687",
    modalBg: "rgba(0, 0, 0, 0.53)",
    success: "#BDE9D5",
    warning: "#FFF7B8",
    danger: "#FFD5DF",
    gray: "#dcecf1",
    soilColor: " #f7e9ff",
    darkPink: "#ba3d79",
  },
  textColor: {
    primary: "#233B67",
    secondary: "#7e93ab",
    tertiary: "#979BA4",
    sucess: "#1E705A",
    warning: " #D8AE1F",
    danger: "#953064",
    filterText: "#3f3356",
  },
  buttonBg: {
    primary: "#404E67",
    secondary: "",
    tertiary: "#FF5687",
  },

  fontSizes: {
    textSize1: "48px",
    textSize2: "36px",
    textSize3: "24px",
    textSize4: "20px",
    textSize5: "18px",
    textSize6: "16px",
    para: "13px",
    // label: "24px",
    link: "16px",
    small: "14px",
  },
  boxShadow: {
    shadowfirst: "0px 8px 22px rgba(70, 128, 255, 0.16)",
    shadowSecond: "0px 2px 15px rgba(0, 0, 0, 0.05)",
  },
};

export default theme;
